import axios from 'axios';
import timeoutPromise from 'Functions/ajax/timeoutPromise';
import getTimeout from 'Functions/ajax/getTimeout';
import getErrors from 'Functions/ajax/getErrors';
const DEFAULT_ERR = 'Connexion impossible pour le moment, ' + 'veuillez vérifier votre connexion ou réessayez ultérieurement.';
export default async function ajaxRequest(url, options = {}) {
  const {
    min_duration = 440
  } = options;
  let req_time = new Date();
  const headers = {};
  if (options.files === true) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  let completed = false;
  try {
    const cancel_token = options.axios_token || axios.CancelToken.source();
    timeoutPromise(options.timeout || options.files ? 100 * 1000 : undefined).then(function () {
      if (completed === false) cancel_token.cancel();
    });
    const config = {
      headers: headers,
      cancelToken: cancel_token.token
    };
    if (options.axios_params) Object.assign(config, options.axios_params);
    const {
      data: response
    } = await axios.post(url, options.data, config);
    completed = true;
    return new Promise(function (resolve) {
      setTimeout(() => resolve(response), getTimeout(req_time, min_duration));
    });
  } catch (e) {
    completed = true;
    if (!e.response?.data) console.error(e);
    const update = {
      ...getErrors({
        response: e.response?.data ? e.response.data : undefined,
        error: e.response?.data?.error || DEFAULT_ERR
      })
    };
    if (e.response?.data?.error_data) {
      try {
        update.error_data = typeof e.response?.data?.error_data === 'string' ? e.response?.data?.error_data : JSON.stringify(e.response?.data?.error_data);
      } catch (e) {
        void 0;
      }
    }
    throw update;
  }
}
